import {Action, ActionCreator} from 'redux';
import {AppDispatch, IStore} from '../index';
import Timer = NodeJS.Timer;

export enum NotificationActionTypes {
    SHOW_NOTIFICATION = '[NOTIFICATION] SHOW',
    HIDE_NOTIFICATION = '[NOTIFICATION] HIDE',
}

export enum NotificationType {
    SUCCESS = 'success',
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error'
}


export interface NotificationPayload {

    type: NotificationType,
    title: string,
    message?: string,
}

export interface NotificationActionParams extends Action<NotificationActionTypes> {
    payload?: NotificationPayload
}

let lastHide: Timer;

export class NotificationActions {

    addError(title: string, message?: string, duration?: number): ActionCreator<void> {
        return this.showNotification(NotificationType.ERROR, title, message, duration);
    }
    addErrorCus(title: string, message?: string, duration?: number): any {
        return this.showNotification(NotificationType.ERROR, title, message, duration);
    }

    addInfo(title: string, message?: string, duration?: number): ActionCreator<void> {
        return this.showNotification(NotificationType.INFO, title, message, duration);
    }
    addInfoCus(title: string, message?: string, duration?: number, type?: NotificationType): any {
        return this.showNotification(type || NotificationType.SUCCESS, title, message, duration);
    }

    addSuccess(title: string, message?: string, duration?: number): ActionCreator<void> {
        return this.showNotification(NotificationType.SUCCESS, title, message, duration);
    }
    addSuccessCus(title: string, message?: string, duration?: number):any {
        return this.showNotification(NotificationType.SUCCESS, title, message, duration);
    }

    addWarning(title: string, message?: string, duration?: number): ActionCreator<void> {
        return this.showNotification(NotificationType.WARNING, title, message, duration);
    }

    showNotification(type: NotificationType, title: string, message?: string, duration?: number): ActionCreator<void> {

        return (dispatch: AppDispatch, getStore: () => IStore) => {

            const show: NotificationActionParams = {
                type: NotificationActionTypes.SHOW_NOTIFICATION,
                payload: {
                    type,
                    title,
                    message,
                }
            };

            const hide = {
                type: NotificationActionTypes.HIDE_NOTIFICATION
            };

            const state = getStore();
            let toRet: NotificationActionParams;

            if (state.notification && state.notification.visible) {
                clearTimeout(lastHide);
                setTimeout(() => {
                    dispatch(show);
                }, 100);
                toRet = hide;
            } else {
                toRet = show;
            }

            lastHide = setTimeout(() => {
                dispatch(hide);
            }, duration || 5000);

            return dispatch(toRet);
        };
    }

    hide() {
        return {type: NotificationActionTypes.HIDE_NOTIFICATION};
    }
}




// WEBPACK FOOTER //
// ./src/store/notification/notification-actions.ts